import { useMemo } from "react"
import { useWindowSize } from "react-use"

import { PageInformation } from "types"

/**
 * 表示環境の情報を取得するhooks
 * @fixme hooksの名前と返すものが乖離しているので命名変更
 */
const usePageInformation = (
  viewerElement: HTMLDivElement | null,
  pageElement: HTMLDivElement | null,
) => {
  const { width, height } = useWindowSize()

  /** 表示可能行数計算 **/
  const pageInformation = useMemo<PageInformation>(() => {
    if (!viewerElement || !pageElement) {
      return {
        maxWidth: 0,
        maxRows: 0,
        width: 0,
        padding: 0,
        lineHeight: 0,
        contentWidth: 0,
      }
    }

    const style = getComputedStyle(viewerElement)
    const fontSize = parseFloat(style.fontSize)
    const lineHeight = fontSize * 2 // 2em

    const bbox = viewerElement.getBoundingClientRect()

    const pageStyle = getComputedStyle(pageElement)
    const padding =
      parseFloat(pageStyle.paddingLeft) + parseFloat(pageStyle.paddingRight)

    const width = bbox.width - padding
    const maxRows = Math.floor(width / lineHeight)
    const maxWidth = maxRows * lineHeight

    const contentWidth = maxWidth + padding

    return {
      maxWidth,
      maxRows,
      width,
      padding,
      lineHeight,
      contentWidth,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height, pageElement, viewerElement, width])

  return { pageInformation }
}
export default usePageInformation
